import {
  Checkbox,
  DatePicker,
  Form,
  Row,
  Col,
  Input,
  Radio,
  Button,
} from "antd";
import TextArea from "antd/es/input/TextArea";
import React, { useState } from "react";

const Index = () => {
  const [form] = Form.useForm();
  // const [contract, setContract] = useState(false);
  const [purchase, setPurchase] = useState(false);
  const [identify, setIdentify] = useState(false);
  const [party, setParty] = useState(false);
  const [partynot, setPartynot] = useState(false);
  const [contract, setContract] = useState(false);
  const [sales, setSales] = useState(false);
  const [documentt, setDocumentt] = useState(false);

  const releaseChange = (e) => {
    if (e.target.value == "Contract_to_Purchase") {
      setContract(true);
      setSales(false);
      setDocumentt(false);
    } else if (e.target.value == "Purchase_and_Sales_Agreement") {
      setSales(true);
      setContract(false);
      setDocumentt(false);
    } else if (e.target.value == "identify_document") {
      setDocumentt(true);
      setContract(false);
      setSales(false);
    }
    console.log(e.target.value);
  };

  const handleChange = (e) => {
    if (e.target.value == "parties_further_authorize") {
      setParty(true);
      setPartynot(false);
    } else if (e.target.value == "partie_not_agree") {
      setParty(false);
      setPartynot(true);
    } else {
      setParty(false);
      setPartynot(false);
    }
  };

  const subData = async (values) => {
    let res = await fetch(
      `${process.env.REACT_APP_BASE_URL}/api/release-from-contracts`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(values),
      }
    );
    const { pdfBase64 } = await res.json();
    const byteCharacters = atob(pdfBase64);
    const byteNumbers = new Array(byteCharacters.length)
      .fill(null)
      .map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);
    console.log("url", url);
    // Create a link element to download the PDF
    const a = document.createElement("a");
    a.href = url;
    a.download = "Release From Contract"; // Set the desired file name
    document.body.appendChild(a);
    a.click();

    // Clean up
    a.remove();
    window.URL.revokeObjectURL(url);
  };

  return (
    <div className="main">
      <Form form={form} autoComplete="off" onFinish={subData}>
        <label>Party agreement</label>
        <Form.Item
          name={"parties_Agreement_Date"}
          rules={[{ required: true, message: "required" }]}
        >
          <DatePicker />
        </Form.Item>
        <div>
          <Form.Item
            name={"release_from_contracts"}
            rules={[{ required: true, message: "required" }]}
          >
            <Radio.Group onChange={releaseChange}>
              <Row gutter={16} justify={"space-between"}>
                <Col>
                  <Radio value={"Contract_to_Purchase"}>
                    Contract to Purchase
                  </Radio>
                </Col>
                <Col>
                  <Radio value="Purchase_and_Sales_Agreement">
                    Purchase and Sales Agreement
                  </Radio>
                </Col>
                <Col>
                  <Radio value={"identify_document"}>identify document</Radio>
                </Col>
              </Row>
            </Radio.Group>
          </Form.Item>
        </div>
        <div>
          {contract && (
            <>
              <label>Date</label>
              <Form.Item
                name={"contract_date"}
                rules={[{ required: true, message: "required" }]}
              >
                <DatePicker />
              </Form.Item>

              <label>Property address</label>
              <Form.Item
                name={"contract_property_address"}
                rules={[{ required: true, message: "required" }]}
              >
                <Input />
              </Form.Item>
            </>
          )}
          {sales && (
            <>
              <label>Date</label>
              <Form.Item
                name={"Sales_contract_date"}
                rules={[{ required: true, message: "required" }]}
              >
                <DatePicker />
              </Form.Item>

              <label>Property address</label>
              <Form.Item
                name={"sales_property_address"}
                rules={[{ required: true, message: "required" }]}
              >
                <Input />
              </Form.Item>
            </>
          )}
          {documentt && (
            <>
              <Row gutter={16} justify={"space-between"}>
                <Col md={8}>
                  <label>Name of document</label>
                  <Form.Item
                    name={"name_of_document"}
                    rules={[{ required: true, message: "required" }]}
                  >
                    <Input placeholder="name" />
                  </Form.Item>
                </Col>
                <Col md={8}>
                  <label>Date</label>
                  <Form.Item
                    name={"date_document"}
                    rules={[{ required: true, message: "required" }]}
                  >
                    <DatePicker />
                  </Form.Item>
                </Col>
                <Col md={8}>
                  <label>Address</label>
                  <Form.Item
                    name={"document_property_address"}
                    rules={[{ required: true, message: "required" }]}
                  >
                    <Input placeholder="address" />
                  </Form.Item>
                </Col>
              </Row>
            </>
          )}
        </div>

        <Row gutter={16} justify={"space-between"}>
          <Col md={10}>
            {identify && (
              <>
                <Form.Item
                  name={"identify_document_text"}
                  rules={[{ required: true, message: "required" }]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  name={"identify_document_date"}
                  rules={[{ required: true, message: "required" }]}
                >
                  <DatePicker />
                </Form.Item>
                <Form.Item
                  name={"identify_document_real_propert_decribed"}
                  rules={[{ required: true, message: "required" }]}
                >
                  <TextArea rows={3} style={{ resize: "none" }} />
                </Form.Item>
              </>
            )}
          </Col>
        </Row>
        <hr />
        <div style={{ marginTop: "2rem" }}>
          <Form.Item
            name="partyOption"
            rules={[{ required: true, message: "Please select an option" }]}
          >
            <Radio.Group style={{ width: "100%" }} onChange={handleChange}>
              <Row>
                <Col md={6}>
                  <Radio value="parties_further_authorize">
                    Agree to release funds
                  </Radio>
                </Col>
                <Col md={6}>
                  <Radio value="partie_not_agree">
                    The parties have not agreed
                  </Radio>
                </Col>
                <Col md={12}></Col>
              </Row>
            </Radio.Group>
          </Form.Item>
          {party && (
            <>
              <Row gutter={8} justify={"space-between"}>
                <Col md={8}>
                  {" "}
                  <label>Name of escrow agent</label>
                  <Form.Item
                    name="name_of_ascrew_agent"
                    rules={[{ required: true, message: "required" }]}
                  >
                    <Input placeholder="Name" />
                  </Form.Item>
                </Col>
                <Col md={8}>
                  {" "}
                  <label>Amount of release</label>
                  <Form.Item
                    name="Amount_of_release"
                    rules={[{ required: true, message: "required" }]}
                  >
                    <Input placeholder="$" />
                  </Form.Item>
                </Col>
                <Col md={8}>
                  {" "}
                  <label>Name and address of recipient</label>
                  <Form.Item
                    name="Escrow_Agent_name_address"
                    rules={[{ required: true, message: "required" }]}
                  >
                    <Input placeholder="Name and address of recipient" />
                  </Form.Item>
                </Col>
              </Row>
            </>
          )}

          {partynot && (
            <>
              <label>Escrow Agent</label>
              <Form.Item
                name="not_agree_escrow_agent"
                rules={[{ required: true, message: "required" }]}
              >
                <Input />
              </Form.Item>
            </>
          )}
        </div>

        <Form.Item>
          <Button htmlType="submit" type="primary">
            Submit
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default Index;
